import { create } from 'zustand';

interface ActiveLocationState {
  activeLocationId: string | null;
  /** When set, the user is scoped to an entire region (activeLocationId should be null). */
  activeRegionId: string | null;
  initialised: boolean;
  initialise: (locationId: string | null) => void;
  setActiveLocationId: (locationId: string | null) => void;
  /** Scope to a region. Clears activeLocationId. */
  setActiveRegionId: (regionId: string | null) => void;
  reset: () => void;
}

const useActiveLocationStore = create<ActiveLocationState>((set) => ({
  activeLocationId: null,
  activeRegionId: null,
  initialised: false,
  initialise: (locationId) =>
    set((state) => {
      if (state.initialised) {
        return state;
      }
      return { activeLocationId: locationId, activeRegionId: null, initialised: true };
    }),
  setActiveLocationId: (locationId) => set({ activeLocationId: locationId, activeRegionId: null, initialised: true }),
  setActiveRegionId: (regionId) => set({ activeRegionId: regionId, activeLocationId: null, initialised: true }),
  reset: () => set({ activeLocationId: null, activeRegionId: null, initialised: false }),
}));

export default useActiveLocationStore;
